import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['empty', 'field', 'option', 'prefix', 'search', 'value'];

  static values = { label: String };

  select({ params: { value, label } }) {
    this.fieldTarget.value = value;
    this.valueTarget.textContent = value === '' ? this.labelValue : label;
    this.prefixTarget.hidden = value === '';

    this.#mark(value);
    this.#close();

    this.element.closest('form').requestSubmit();
  }

  filter() {
    const needle = this.searchTarget.value.trim().toLowerCase();
    const matches = this.optionTargets.filter((option) => {
      const hit = option.dataset.filterMenuLabelParam.toLowerCase().includes(needle);

      option.classList.toggle('hidden', !hit);

      return hit;
    });

    this.emptyTarget.classList.toggle('hidden', matches.length > 0);
  }

  reset() {
    if (!this.hasSearchTarget || this.searchTarget.value === '') return;

    this.searchTarget.value = '';
    this.filter();
  }

  #mark(value) {
    for (const option of this.optionTargets) {
      const chosen = option.dataset.filterMenuValueParam === value;

      option.setAttribute('aria-checked', String(chosen));
      option.querySelector('[data-role="check"]').classList.toggle('hidden', !chosen);
    }
  }

  #close() {
    this.application.getControllerForElementAndIdentifier(this.element, 'action-menu')?.close();
  }
}
